import styled from 'styled-components';

export default styled.div`
    background-color: white;
    box-sizing: border-box;
    padding: 15px;
`;
